// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://glyelurvdvrbqeyklseh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdseWVsdXJ2ZHZyYnFleWtsc2VoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk0NDQzNzEsImV4cCI6MjA4NTAyMDM3MX0._fB90EOfQdF-E-96BLpldcAYlrsU-7P9Tvl-B6bDV4s";

// NOTE: This is the UNAUTHENTICATED base client. It does NOT include x-session-token.
// For authenticated requests, always use getAuthenticatedClient() from services/client.ts
// The only valid use of this bare client is for the initial verify_pin RPC during login.

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});